export const SET_SNACKBAR = "teamly/settings/SET_SNACKBAR";

const initialState = {
  snackbarOpen: false,
  snackbarType: "success",
  snackbarMessage: "",
  completedItems: 1,
  totalItems: 1
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SNACKBAR:
      const { snackbarOpen, snackbarMessage, snackbarType, completedItems, totalItems } = action;
      return {
        ...state,
        snackbarOpen,
        snackbarType,
        snackbarMessage,
        completedItems,
        totalItems
      };
    default:
      return state;
  }
};

export const setSnackbar = (
  snackbarOpen,
  snackbarType = "success",
  snackbarMessage = "",
  completedItems = 1,
  totalItems = 1
) => ({
  type: SET_SNACKBAR,
  snackbarOpen,
  snackbarType,
  snackbarMessage,
  completedItems,
  totalItems
});
